'use client';

/**
 * SignedOutNotice (A70)
 *
 * Shown on the sign-in page when the server ended the officer's session for inactivity
 * (`/login?reason=idle`, sent by GlobalReauthHandler via performSessionEndedSignout). The reason is parsed
 * against an allowlist; unknown values render nothing, and the raw query text is never rendered.
 * ('session_expired' keeps the login page's existing message, so it renders nothing here.)
 */

import { Clock } from 'lucide-react';
import { parseSignedOutReason } from '@/lib/auth/logout';

export const IDLE_SIGNED_OUT_MESSAGE =
  // No minute count here on purpose: the server's GOTRUE_SESSIONS_INACTIVITY_TIMEOUT is the only clock, and a
  // number in the UI would drift from it.
  'You were signed out after a period of inactivity. Please sign in again.';

export function SignedOutNotice({ reason }: { reason: string | null | undefined }) {
  if (parseSignedOutReason(reason) !== 'idle') return null;
  return (
    <div
      role="status"
      data-testid="signed-out-notice"
      className="flex items-start gap-3 p-4 bg-amber-500/10 border border-amber-500/30 rounded-lg"
    >
      <Clock className="h-5 w-5 text-amber-400 flex-shrink-0 mt-0.5" aria-hidden="true" />
      <p className="text-sm text-amber-300">{IDLE_SIGNED_OUT_MESSAGE}</p>
    </div>
  );
}
